import { render } from "./AppointmentDetailComponent.vue?vue&type=template&id=9e2377b4&scoped=true"
import script from "./AppointmentDetailComponent.vue?vue&type=script&lang=js"
export * from "./AppointmentDetailComponent.vue?vue&type=script&lang=js"

import "./AppointmentDetailComponent.vue?vue&type=style&index=0&id=9e2377b4&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9e2377b4"]])

export default __exports__